import { UserRole } from "../../enum/user";

export const getUserInfo = (state) => state?.my_account?.user_info;
export const getUserRole = (state) => state?.my_account?.user_info?.role;
export const getIsAdmin = (state) => state?.my_account?.user_info?.role == UserRole.Admin;
export const isPro = (state) => state?.my_account?.is_pro_member;
export const getCurrentProUser = (state) =>
  state?.my_account?.userInfo?.subscription_type === "PRO" || state?.my_account?.userInfo?.subscription_type === "PRO_MONTH";
